import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import styled, { css } from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";
import { FEEDBACK_TYPES } from "shared/config/feedbackTypes";
import HStack from "shared/components/layout/stack/HStack";
import TextInputField from "shared/components/inputs/input/TextInput";
import { TextInputStylesError } from "shared/components/inputs/input/TextInput.styles";
import { TimesheetCell } from "features/timesheet/timesheet-grid/TimesheetGrid.styles";
import { mediaQueries } from "shared/config/breakpoints";

export const InputFieldWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const StyledTextInput = styled(TextInputField)`
    border-left: none;
    border-right: none;
    border-top: none;
    border-radius: 0;
    height: 100%;
    margin-bottom: -1px;
    padding: 16px 12px;
    color: ${COLOR_VALUES.Gray_1};
    border-color: transparent;

    ${TEXT_VARIANT_STYLES.Body_2_2}

    ${mediaQueries.small} {
        padding: 8px 4px;
        font-size: 0.75rem;
    }

    &:hover {
        color: ${COLOR_VALUES.Black};

        &::placeholder {
            color: inherit;
        }
    }

    &:focus {
        border-color: ${COLOR_VALUES.Gray_2};
    }

    ${(props) =>
        props.feedbackType === FEEDBACK_TYPES.Error &&
        css`
            ${TextInputStylesError}
        `}

    &:disabled {
        background: transparent;
        border-color: transparent;
    }
`;

export const StyledTimesheetCell = styled(TimesheetCell)`
    padding: 0;
    display: flex;
    align-items: center;
    ${(props) =>
        props.disabled &&
        css`
            cursor: not-allowed;
            color: ${COLOR_VALUES.Gray_3};
            background: ${COLOR_VALUES.Gray_8};
        `}
`;



export const StyledTextCell = styled(Text)`
    padding: 16px 12px;
    
    ${mediaQueries.small} {
        padding: 8px 4px;
        font-size: 0.75rem;
    }
`;

export const ReadOnlyCellWrapper = styled(HStack)`
    width: 100%;
`;
